module.exports = __webpack_public_path__ + "static/media/bg4.e5241971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg4.jpg
// module id = 164
// module chunks = 0